export default "__VITE_ASSET__c9142e7c__"